<script setup>
import {ref} from "vue";

const pendingNotificationsList = ref()

const onNotificationCreated = () => {
    pendingNotificationsList.value.loadNotifications()
}

</script>
<template>
    <div>
        <frosted-bar>
            <h1>{{ _mft('notification:domainNamePlural') }}</h1>
        </frosted-bar>
        <ui-tabbed>
            <ui-tabbed-tab
                value="scheduled-notifications"
                :title="_mft('whitelabelApp:scheduledNotifications.title')"
                :active="true"
            >
                <whitelabel-app-notification-list
                    ref="pendingNotificationsList"
                    status="scheduled"
                />
            </ui-tabbed-tab>
            <ui-tabbed-tab
                value="sent-notifications"
                :title="_mft('whitelabelApp:sentNotifications.title')"
            >
                <whitelabel-app-notification-list
                    status="sent"
                />
            </ui-tabbed-tab>
            <ui-tabbed-tab
                value="create-notification"
                title="Create notification"
            >
                <whitelabel-app-notification-composer
                    @created="onNotificationCreated"
                />
            </ui-tabbed-tab>
        </ui-tabbed>
    </div>
</template>
